import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";

export const Story = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section ref={ref} data-testid="story-section" className="relative mx-auto grid max-w-[1400px] items-center gap-12 px-5 py-24 sm:px-8 sm:py-32 lg:grid-cols-2">
      <Reveal className="relative aspect-[4/5] overflow-hidden rounded-[28px] spotlight">
        <motion.img style={{ y }} src="/images/beratung-am-pool.jpg" alt="Persönliche Beratung am Pool" className="h-[116%] w-full object-cover object-[28%_center] -mt-[8%]" />
      </Reveal>
      <div>
        <Reveal><Eyebrow>Unsere Geschichte</Eyebrow></Reveal>
        <Reveal delay={0.08}>
          <blockquote className="mt-6 font-display text-3xl sm:text-4xl lg:text-5xl font-medium leading-[1.08] tracking-[-0.025em]">
            „Unsere Reise begann mit unserem eigenen Pool.“
          </blockquote>
        </Reveal>
        <Reveal delay={0.14}>
          <p className="mt-8 text-base sm:text-lg leading-relaxed text-[var(--mist)]">
            Gala-, Schwimmteich- und Poolbauer gaben sich die Klinke in die Hand – am Ende mussten wir selbst Hand anlegen, von der Stromzuführung bis zur Inbetriebnahme. Genau diese Erfahrung ist heute unser Wissen.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-5 text-base sm:text-lg leading-relaxed text-[var(--foam)]">
            Nach unzähligen Kundenprojekten entwickeln wir Poolsteuerungen in unserem Haus – individuell nach Ihren Wünschen.
          </p>
          <p className="mt-8 font-mono text-xs uppercase tracking-[0.25em] text-[var(--lagoon)]">the coolpool company GmbH</p>
        </Reveal>
      </div>
    </section>
  );
};
